import * as React from 'react';

import styled from 'styled-components';

import CircleArrowIcon from '@components/basics/icons/circle-arrow';
import Flex from '@components/layout/flex';

interface DecorationDropdownProps {
  className?: string;
  listOpen?: boolean;
  children?: React.ReactNode;
  hideArrow?: boolean;
}

export const DecorationDropdown: React.FC<DecorationDropdownProps> = (
  props
) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      className={props.className}
    >
      {props.children}
      {!props.hideArrow && (
        <CircleArrowIcon
          className="arrow"
          size="16px"
          arrowUp={props.listOpen}
        />
      )}
    </Flex>
  );
};

export default styled(DecorationDropdown)`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 20px;
  height: 20px;

  @media ${({ theme }) => theme.device.tablet} {
    width: 28px;
    height: 28px;
  }

  .arrow {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.inputBackground};
  }
`;
